import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index';
import chatApi from '@/request/customer/customerRoom'
import {Decrypt} from '@/request/customer/util.js'

Vue.use(VueRouter)
import Layout from '@/views/Layout/index';
import page404 from '@/views/404';
import pageBlank from '@/views/blank';
import Login from '@/views/Login/index';
import ForgetPassword from '@/views/Login/ForgetPassword/index';
import Register from '@/views/Login/Register/index';
import Download from '@/views/Download/index';
import BannerPage from '@/views/Home/BannerPage/index';
import SellerContract from '@/views/Contract/sellerContract.vue';
import checkRecords from '@/views/Contract/checkRecords.vue';
import BuyerContract from '@/views/Contract/buyerContract.vue';
import IndemnityContract from '@/views/Contract/indemnityContract.vue';
import SubmitSuccess from '@/views/Contract/submitSuccess.vue';
import certContractSign from '@/views/Contract/certContractSign.vue';
import submitOutcome from '@/views/Contract/submitOutcome.vue';
import burerSubmitOutcome from '@/views/Contract/burerSubmitOutcome.vue';
import Questionnaire from '@/views/Questionnaire/index';
import WinnersList from '@/views/Questionnaire/winnersList';
import HelpDetail from '@/views/HelpCenter/helpDetail';
import CustomerSer from '@/views/CustomerSer/index';
import roomInfo from '@/views/CustomerSer/roomInfo.vue';
import statistics from '@/views/Home/statistics.vue';
import RealnameCertification from '@/views/Contract/realnameCertification.vue'
import SellerInformation from "@/views/Contract/sellerInformation.vue"
import BuyerInformation from "@/views/Contract/buyerInformation.vue"
import { imInit } from '@/util/im';
import {getLotteryKeyPop} from "../request/API";
import Dev from '@/views/Dev';

/** 开发状态 */
export const DevStatus = {
  noNeed: '无需调整',
  untouched: '待换皮',
  acccomplished: '换皮完毕',
}

export const routes = [
  {
    path: '/dev',
    name: 'Dev',
    component: () => import("@/views/Dev/index"),
    meta: { devStatus: DevStatus.noNeed },
    redirect: process.env.VUE_APP_ENV === 'production' ? '/404' : undefined,
  },
  {
    path: "/",
    component: Layout,
    redirect: "/",
    meta: { devStatus: DevStatus.acccomplished },
    children: [
      // 首页
      {
        path: "/",
        name: "Home",
        component: () => import("@/views/Home/index"),
        meta: { keepAlive: true, devStatus: DevStatus.acccomplished },
      },
      // 中介担保
      {
        path: "/vouch",
        name: "Vouch",
        component: () => import("@/views/Home/SellPop/vouch"),
        meta: { keepAlive: false, devStatus: DevStatus.acccomplished }
      },
      // 客服中心
      {
        path: "/home/cusSerCenter",
        name: "CusSerCenter",
        component: () => import("@/views/Home/CusSerCenter/index"),
        meta: {
          keepAlive: false,
          auth: true,
          devStatus: DevStatus.acccomplished }
      },
      // 客服中心 客服列表
      {
        path: "/home/cusSerCenter/cusSerList",
        name: "cusSerList",
        component: () => import("@/views/Home/CusSerCenter/cusSerList"),
        meta: {
          keepAlive: false,
          auth: true,
          devStatus: DevStatus.acccomplished }
      },
      // 客服中心 客服列表 旧
      {
        path: "/home/cusSerCenter/cusSerListOld",
        name: "cusSerListOld",
        component: () => import("@/views/Home/CusSerCenter/cusSerListOld"),
        meta: {
          keepAlive: false,
          auth: true,
          devStatus: DevStatus.acccomplished }
      },
      //每日成交 更多
      {
        path: "/home/dailyTransaction",
        name: "DailyTransaction",
        component: () => import("@/views/Home/DailyTransaction/index"),
        meta: { keepAlive: true, devStatus: DevStatus.acccomplished }
      },
      //每日成交详情
      {
        path: "/home/dailyTxDetails",
        name: "DailyTxDetails",
        component: () => import("@/views/Home/DailyTxDetails/index"),
        meta: { keepAlive: false, devStatus: DevStatus.acccomplished }
      },
      //装备每日成交详情
      {
        path: "/allGame/dailyTxDetailsEquip",
        name: "DailyTxDetailsEquip",
        component: () => import("@/views/AllGame/DailyTxDetailsEquip/index"),
        meta: { keepAlive: false, devStatus: DevStatus.acccomplished }
      },
      //公告 更多
      {
        path: "/home/announcement",
        name: "Announcement",
        component: () => import("@/views/Home/Announcement/index"),
        meta: { keepAlive: false, devStatus: DevStatus.acccomplished }
      },
      //文章
      {
        path: "/home/article",
        name: "Article",
        component: () => import("@/views/Home/Article/index"),
        meta: { keepAlive: false, devStatus: DevStatus.acccomplished }
      },
      // 账号回收
      {
        path: "accRecycle",
        name: "AccountRecycle",
        component: () => import("@/views/AccountDeal/AccountRecycle/index"),
        meta: { keepAlive: false, devStatus: DevStatus.acccomplished }
      },
      // 号商详情
      {
        path: "/accountRecycle/recyclingInfo",
        name: "RecyclingInfo",
        component: () =>
          import("@/views/AccountDeal/AccountRecycle/RecyclingInfo/index"),
        meta: { keepAlive: true, devStatus: DevStatus.acccomplished }
      },
      // 我要卖号
      {
        path: "accountSell",
        name: "AccountSell",
        meta: { auth: true, keepAlive: false, devStatus: DevStatus.acccomplished },
        component: () => import("@/views/AccountDeal/AccountSell/new")
      },
      // 账号估价
      {
        path: "/accountValuation",
        name: "AccountValuation",
        meta: { auth: true, keepAlive: false, devStatus: DevStatus.acccomplished },
        component: () => import("@/views/AccountValuation/index")
      },
      // 查看估价信息
      {
        path: "/valuationInformation",
        name: "ValuationInformation",
        meta: { auth: true, keepAlive: false, devStatus: DevStatus.acccomplished },
        component: () =>
          import("@/views/AccountValuation/ValuationInformation/index")
      },
      // 关于我们
      {
        path: "about",
        name: "About",
        component: () => import("@/views/About/index"),
        meta: { keepAlive: false, devStatus: DevStatus.acccomplished }
      },
      // 公司法务
      {
        path: "legal",
        name: "Legal",
        component: () => import("@/views/Legal/index"),
        meta: { keepAlive: false, devStatus: DevStatus.acccomplished }
      },
      // 原神代练
      {
        path: "training",
        name: "Training",
        component: () => import("@/views/AllGame/Training/index"),
        meta: { keepAlive: false, devStatus: DevStatus.acccomplished }
      },
      // 自抽号
      {
        path: "selfDraw",
        name: "SelfDraw",
        component: () => import("@/views/AllGame/selfDraw/index"),
        meta: { keepAlive: false, devStatus: DevStatus.acccomplished }
      },
      // 全部游戏
      {
        path: "allGame",
        name: "AllGame",
        component: () => import("@/views/AllGame/index"),
        meta: { keepAlive: true, devStatus: DevStatus.acccomplished }
      },
      // 账号交易 我要买号
      {
        path: "accountTrade/allGame",
        name: "accountTradeAllGame",
        redirect: "allGame",
        component: () => import("@/views/AllGame/index"),
        meta: { keepAlive: true, devStatus: DevStatus.acccomplished }
      },
      // 游戏列表筛选
      {
        path: "selectgame",
        name: "SelectGame",
        component: () => import("@/views/AllGame/selectGame/index"),
        meta: { keepAlive: false, devStatus: DevStatus.acccomplished }
      },
      // 游戏列表筛选 缺省页
      {
        path: "selectgameempty",
        name: "SelectGameEmpty",
        component: () => import("@/views/AllGame/selectGame/empty"),
        meta: { keepAlive: false, devStatus: DevStatus.acccomplished }
      },
      // 账号详情
      {
        path: "gamedetails",
        name: "GameDetails",
        component: () => import("@/views/AllGame/gameDetails/index"),
        meta: { keepAlive: false, devStatus: DevStatus.acccomplished }
      },
      //诚意买 支付结果
      {
        path: "payResult",
        name: "payResult",
        component: resolve =>
          require(["@/views/MethodOfPayment/payResult"], resolve),
        meta: { keepAlive: false, devStatus: DevStatus.acccomplished }
      },
      // 金币详情
      {
        path: "golddetails",
        name: "GoldDetails",
        component: () => import("@/views/AllGame/goldDetails/index"),
        meta: { keepAlive: false, devStatus: DevStatus.acccomplished }
      },
      // 装备详情
      {
        path: "equipmentdetails",
        name: "EquipmentDetails",
        component: () => import("@/views/AllGame/equipmentDetails/index"),
        meta: { keepAlive: false, devStatus: DevStatus.acccomplished }
      },
      /*      // 立即购买交易页面
      {
        path: 'onlineDeal',
        name: 'OnlineDeal',
        component: () => import('@/views/AllGame/onlineDeal/index')
      },*/
      // 立即购买交易页面
      {
        path: "onlineDeal",
        name: "OnlineDeal",
        component: () => import("@/views/AllGame/onlineDeal/new"),
        meta: { auth: true, devStatus: DevStatus.acccomplished }
      },
      // 立即购买交易页面 购买协议
      {
        path: "agreement",
        name: "Agreement",
        component: () => import("@/views/AllGame/onlineDeal/agreement"),
        meta: { auth: true, devStatus: DevStatus.noNeed }
      },
      // 立即购买支付页面
      {
        path: "payment",
        name: "Payment",
        component: () => import("@/views/AllGame/onlineDeal/payment"),
        meta: { auth: true, devStatus: DevStatus.noNeed }
      },
      // 诚心卖支付页面
      {
        path: "sinceritypayment",
        name: "Sinceritypayment",
        component: () =>
          import("@/views/AccountDeal/AccountSell/sincerityPayMent"),
        meta: { auth: true, devStatus: DevStatus.acccomplished }
      },
      // 卖家须知
      {
        path: "sellAgreement",
        name: "SellAgreement",
        component: () =>
          import("@/views/AccountDeal/AccountSell/sellAgreement"),
        meta: { auth: true, devStatus: DevStatus.noNeed }
      },
      //黑号验证
      {
        path: "blacknumverify",
        name: "BlackNumVerify",
        component: () => import("@/views/Verify/BlackNumVerify/index"),
        meta: { auth: true, keepAlive: false, devStatus: DevStatus.acccomplished }
      },
      // 客服验证
      {
        path: "cusserverify",
        name: "CusSerVerify",
        component: () => import("@/views/Verify/CusSerVerify/index"),
        meta: { keepAlive: false, devStatus: DevStatus.noNeed }
      },
      // 个人中心
      {
        path: "personalCenter",
        name: "PersonalCenter",
        redirect: "/personalCenter/myAccount",
        meta: { auth: true, keepAlive: false, devStatus: DevStatus.acccomplished },
        component: () => import("@/views/PersonalCenter/index"),
        children: [
          //我的账号
          {
            path: "/personalCenter/myAccount",
            name: "MyAccount",
            component: resolve =>
              require(["@/views/PersonalCenter/MyAccount/index"], resolve),
            meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
          },
          //我是卖家 游戏账号
          {
            path: "/personalCenter/seller",
            name: "Seller",
            component: resolve =>
              require(["@/views/PersonalCenter/Seller/index"], resolve),
            meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
          },
          //我是卖家 账号详情
          {
            path: "/personalCenter/seller/sellInfo",
            name: "SellerDetail",
            component: resolve =>
              require(["@/views/PersonalCenter/Seller/sellInfo"], resolve),
            meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
          },
          //我是卖家 游戏金币
          {
            path: "/personalCenter/seller/gold",
            name: "SellerGold",
            component: resolve =>
              require(["@/views/PersonalCenter/Seller/gold"], resolve),
            meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
          },
          //我是卖家 游戏装备
          {
            path: "/personalCenter/seller/equip",
            name: "SellerEquip",
            component: resolve =>
              require(["@/views/PersonalCenter/Seller/equip"], resolve),
            meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
          },
          //我是卖家 收到的降价请求
          {
            path: "/personalCenter/seller/bargain",
            name: "SellerBargain",
            component: resolve =>
              require(["@/views/PersonalCenter/Seller/bargain"], resolve),
            meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
          },
          //我是卖家 收到的议价请求
          {
            path: "/personalCenter/seller/bargainPrice",
            name: "SellerBargainPrice",
            component: resolve =>
              require(["@/views/PersonalCenter/Seller/bargainPrice"], resolve),
            meta: { keepAlive: false, devStatus: DevStatus.acccomplished }
          },
          //我是卖家 我的服务订单
          {
            path: "/personalCenter/seller/sincerity",
            name: "SellerSincerity",
            component: resolve =>
              require([
                "@/views/PersonalCenter/Seller/sincerity/index"
              ], resolve),
            meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
          },
          //我是卖家 我的服务订单-商品详情
          {
            path: "/personalCenter/seller/sincerity/detail",
            name: "SellerSincerityDetail",
            component: resolve =>
              require([
                "@/views/PersonalCenter/Seller/sincerity/detail"
              ], resolve),
            meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
          },
          //我是买家 账号订单
          {
            path: "/personalCenter/buyer",
            name: "Buyer",
            component: resolve =>
              require(["@/views/PersonalCenter/Buyer/index"], resolve),
            meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
          },
          //我是买家 支付详情
          {
            path: "/personalCenter/buyer/payDetail",
            name: "BuyerDetail",
            component: resolve =>
              require(["@/views/PersonalCenter/Buyer/detail"], resolve),
            meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
          },
          //我是买家 金币订单
          {
            path: "/personalCenter/buyer/gold",
            name: "BuyerGold",
            component: resolve =>
              require(["@/views/PersonalCenter/Buyer/gold"], resolve),
            meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
          },
          //我是买家 装备订单
          {
            path: "/personalCenter/buyer/equip",
            name: "BuyerEquip",
            component: resolve =>
              require(["@/views/PersonalCenter/Buyer/equip"], resolve),
            meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
          },
          //发起的降价请求
          {
            path: "/personalCenter/buyer/bargain",
            name: "BuyerBargain",
            component: resolve =>
              require(["@/views/PersonalCenter/Buyer/bargain"], resolve),
            meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
          },
          //发起的降价请求-new
          {
            path: "/personalCenter/buyer/bargainPrice",
            name: "BuyerBargainPrice",
            component: resolve =>
              require(["@/views/PersonalCenter/Buyer/bargainPrice"], resolve),
            meta: { keepAlive: false, devStatus: DevStatus.acccomplished }
          },
          //我的收藏 游戏账号
          {
            path: "/personalCenter/myCollection",
            name: "MyCollection",
            component: resolve =>
              require(["@/views/PersonalCenter/MyCollection/index"], resolve),
            meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
          },
          //我的收藏 游戏金币
          {
            path: "/personalCenter/myCollection/gold",
            name: "MyCollectionGold",
            component: resolve =>
              require(["@/views/PersonalCenter/MyCollection/gold"], resolve),
            meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
          },
          //我的收藏 游戏装备
          {
            path: "/personalCenter/myCollection/equip",
            name: "MyCollectionEquip",
            component: resolve =>
              require(["@/views/PersonalCenter/MyCollection/equip"], resolve),
            meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
          },
          //个人中心
          {
            path: "/personalCenter/personalInfo",
            name: "PersonalInfo",
            component: resolve =>
              require(["@/views/PersonalCenter/PersonalInfo/index"], resolve),
            meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished },
            children: [
              //个人信息
              {
                path: "",
                name: "BasicInfo",
                component: resolve =>
                  require([
                    "@/views/PersonalCenter/PersonalInfo/BasicInfo/index"
                  ], resolve),
                meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
              },
              //实名认证
              {
                path: "/personalCenter/personalInfo/rNameAuthentication",
                name: "RNameAuthentication",
                component: resolve =>
                  require([
                    "@/views/PersonalCenter/PersonalInfo/RNameAuthentication/index"
                  ], resolve),
                meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
              },
              //修改登录密码
              {
                path: "/personalCenter/personalInfo/modifyLoginPwd",
                name: "ModifyLoginPwd",
                component: resolve =>
                  require([
                    "@/views/PersonalCenter/PersonalInfo/ModifyLoginPwd/index"
                  ], resolve),
                meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
              },
              //设置体现账户
              {
                path: "/personalCenter/personalInfo/withdrawalAccount",
                name: "WithdrawalAccount",
                component: resolve =>
                  require([
                    "@/views/PersonalCenter/PersonalInfo/WithdrawalAccount/index"
                  ], resolve),
                meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
              },
              //支付密码
              {
                path: "/personalCenter/personalInfo/paymentPwd",
                name: "PaymentPwd",
                component: resolve =>
                  require([
                    "@/views/PersonalCenter/PersonalInfo/PaymentPwd/index"
                  ], resolve),
                meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
              },
              //支付密码
              {
                path: "/personalCenter/personalInfo/changeTelphone",
                name: "ChangeTelphone",
                component: resolve =>
                  require([
                    "@/views/PersonalCenter/PersonalInfo/ChangeTelphone/index"
                  ], resolve),
                meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
              }
            ]
          },
          //财务中心
          {
            path: "/personalCenter/financialCenter",
            name: "FinancialCenter",
            component: resolve =>
              require([
                "@/views/PersonalCenter/FinancialCenter/index"
              ], resolve),
            meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished },
            children: [
              //充值
              {
                path: "",
                name: "Recharge",
                component: resolve =>
                  require([
                    "@/views/PersonalCenter/FinancialCenter/Recharge/index"
                  ], resolve),
                meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
              },
              //提现
              {
                path: "/personalCenter/financialCenter/withdraw",
                name: "Withdraw",
                component: resolve =>
                  require([
                    "@/views/PersonalCenter/FinancialCenter/Withdraw/index"
                  ], resolve),
                meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
              },
              //提现记录
              {
                path: "/personalCenter/financialCenter/withdrawRecord",
                name: "WithdrawRecord",
                component: resolve =>
                  require([
                    "@/views/PersonalCenter/FinancialCenter/WithdrawRecord/index"
                  ], resolve),
                meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
              },
              //收支明细
              {
                path: "/personalCenter/financialCenter/moneyDetails",
                name: "MoneyDetails",
                component: resolve =>
                  require([
                    "@/views/PersonalCenter/FinancialCenter/MoneyDetails/index"
                  ], resolve),
                meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
              }
            ]
          },
          //站内通知
          {
            path: "/personalCenter/siteNotice",
            name: "SiteNotice",
            component: resolve =>
              require(["@/views/PersonalCenter/SiteNotice/index"], resolve),
            meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
          },
          //聊天室列表
          {
            path: "/chat/list",
            name: "ChatList",
            component: resolve => require(["@/views/chat/list"], resolve),
            meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
          },
          //聊天室列表 旧
          {
            path: "/chat/listOld",
            name: "ChatList",
            component: resolve => require(["@/views/chat/listOld"], resolve),
            meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
          },
          //最近浏览
          {
            path: "/personalCenter/accHistory",
            name: "AccHistory",
            component: resolve =>
              require(["@/views/PersonalCenter/History/account"], resolve),
            meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
          },
          //咨询记录
          {
            path: "/personalCenter/serHistory",
            name: "SerHistory",
            component: resolve =>
              require(["@/views/PersonalCenter/History/service"], resolve),
            meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
          },
          //合同中心
          {
            path: "/personalCenter/contractCenter",
            name: "ContractCenter",
            component: resolve =>
              require(["@/views/PersonalCenter/ContractCenter/index"], resolve),
            meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished },
            children: [
              //合同信息
              {
                path: "",
                name: "ContractInfo",
                component: resolve =>
                  require([
                    "@/views/PersonalCenter/ContractCenter/ContractInfo/index"
                  ], resolve),
                meta: { keepAlive: false,auth: true, devStatus: DevStatus.acccomplished }
              }
            ]
          },
          //站内通知
          {
            path: "/personalCenter/coupon",
            name: "Coupon",
            component: resolve =>
              require(["@/views/PersonalCenter/Coupon/index"], resolve),
            meta: { keepAlive: false, auth: true, devStatus: DevStatus.acccomplished }
          },
          // 我的奖品
          {
            path: "/personalCenter/Reward",
            name: "Reward",
            component: resolve =>
              require(["@/views/PersonalCenter/Reward/index"], resolve),
            meta: { keepAlive: false, auth: true, devStatus: DevStatus.acccomplished }
          },
        ]
      },
      // 交易必看
      {
        path: "tradeTip",
        name: "TradeTip",
        component: () => import("@/views/TradeTip/index"),
        meta: { keepAlive: false, devStatus: DevStatus.acccomplished }
      },
      // 中介担保
      {
        path: "intermediaryGuarantee",
        name: "IntermediaryGuarantee",
        component: () => import("@/views/TradeTip/intermediaryGuarantee"),
        meta: { keepAlive: true, devStatus: DevStatus.acccomplished }
      },
      // 帮助中心
      {
        path: "helpCenter",
        name: "helpCenter",
        component: resolve => require(["@/views/HelpCenter/index"], resolve),
        meta: { keepAlive: false, devStatus: DevStatus.acccomplished }
      },
      {
        path: "/helpCenter/search",
        name: "helpCenterSearch",
        component: resolve => require(["@/views/HelpCenter/search"], resolve),
        meta: { keepAlive: false, devStatus: DevStatus.acccomplished }
      },
      // 收银台
      {
        path: "/MethodOfPayment",
        name: "MethodOfPayment",
        component: resolve =>
          require(["@/views/MethodOfPayment/index"], resolve),
        meta: { keepAlive: false, devStatus: DevStatus.acccomplished }
      },
      // 优惠券
      {
        path: "/channel",
        name: "Coupon",
        component: resolve => require(["@/views/Coupon/index"], resolve),
        meta: { keepAlive: false, devStatus: DevStatus.acccomplished }
      },
      // Cj活动
      {
        path: "/cj",
        name: "Cj",
        component: resolve => require(["@/views/Cj/index"], resolve),
        meta: { keepAlive: false, devStatus: DevStatus.noNeed }
      }
    ],
  },
  // 蟹蟹有你活动
  {
    path: "/xx-having-you",
    component: resolve => require(["@/views/XXHavingYou/index"], resolve),
    meta: { keepAlive: false, devStatus: DevStatus.noNeed }
  },
  {
    path: "/leaveMsg",
    component: resolve => require(["@/views/LeaveMsg/index"], resolve),
    meta: { devStatus: DevStatus.noNeed }
  },
  // 404page
  {path: '/404', name: 'page404', component: page404, meta: { devStatus: DevStatus.acccomplished }},
  {path: '/payserveBlank', name: 'pageBlank', component: pageBlank, meta: { devStatus: DevStatus.noNeed }},
  {path: '/login', name: 'Login', component: Login, meta: { devStatus: DevStatus.acccomplished }},
  {path: '/forgetpassword', name: 'ForgetPassword', component: ForgetPassword, meta: { devStatus: DevStatus.acccomplished }},
  {path: '/register', name: 'Register', component: Register, meta: { devStatus: DevStatus.acccomplished }},
  {path: '/download', name: 'Download', component: Download, meta: { devStatus: DevStatus.noNeed }},
  {path: '/bannerPage', name: 'BannerPage', component: BannerPage, meta: { devStatus: DevStatus.noNeed }},
  {path: '/sellerContract', name: 'SellerContract', component: SellerContract, meta: { devStatus: DevStatus.acccomplished }},
  {path: '/checkRecords', name: 'checkRecords', component: checkRecords, meta: { devStatus: DevStatus.acccomplished }},
  {path: '/buyerContract', name: 'BuyerContract', component: BuyerContract, meta: { devStatus: DevStatus.acccomplished }},
  {path: '/indemnity', name: 'IndemnityContract', component: IndemnityContract, meta: { devStatus: DevStatus.acccomplished }},
  {path: '/submitSuccess', name: 'SubmitSuccess', meta: {auth: true, devStatus: DevStatus.acccomplished }, component: SubmitSuccess},
  {path: '/certContractSign', name: 'CertContractSign', component: certContractSign, meta: { devStatus: DevStatus.acccomplished }},
  {path: '/submitOutcome', name: 'SubmitOutcome', meta: {auth: true, devStatus: DevStatus.acccomplished }, component: submitOutcome},
  {path: '/burerSubmitOutcome', name: 'BurerSubmitOutcome', meta: {auth: true, devStatus: DevStatus.acccomplished }, component: burerSubmitOutcome},
  {path: '/questionnaire', name: 'Questionnaire', component: Questionnaire, meta: { devStatus: DevStatus.acccomplished }},
  {path: '/winnersList', name: 'WinnersList', component: WinnersList, meta: { devStatus: DevStatus.acccomplished }},
  {path: '/customerSer', name: 'CustomerSer', meta: {auth: true, devStatus: DevStatus.acccomplished }, component: CustomerSer},
  {path: '/chatRoom', name: 'chatRoom', meta: {auth: true, devStatus: DevStatus.acccomplished }, component: () => import('@/views/chat/room')},
  {path: '/helpDetail', name: 'helpDetail', component: HelpDetail, meta: { devStatus: DevStatus.acccomplished }},
  {path: '/roomInfo', name: 'roomInfo', component: roomInfo, meta: { devStatus: DevStatus.noNeed }},
  {path: '/bdSs', name: 'statistics', component: statistics, meta: { devStatus: DevStatus.noNeed }},
  {path:'/realnameCertification',name:'realnameCertification',component:RealnameCertification, meta: { devStatus: DevStatus.acccomplished }},
  {path:'/sellerInformation',name:'sellerInformation',component:SellerInformation, meta: { devStatus: DevStatus.acccomplished }},
  {path:'/buyerInformation',name:'buyerInformation',component:BuyerInformation, meta: { devStatus: DevStatus.acccomplished }},
  {
    path: "*", // 页面不存在的情况下会跳到404页面
    redirect: "/",
    name: "notFound",
    hidden: true,
    meta: { devStatus: DevStatus.noNeed }
  }
];

const getCusToken = function() {
  if (
    localStorage.getItem("cusetomerTokens") !== null &&
    localStorage.getItem("cusetomerTokens") !== ""
  ) {
    Vue.prototype.$WSIM.createSocket();
    return;
  } else {
    if(store.state.userData.telphone){
      chatApi
        .getToken({
          format: "json",
          type: 2,
          userid: store.state.userData.telphone
        })
        .then(res => {
          localStorage.setItem(
            "cusetomerTokens",
            JSON.parse(Decrypt(res.msg)).token
          );
          Vue.prototype.$WSIM.createSocket();
        });
    }
  }
};

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

const foxNext = (to, from, next) => {
  if (from.query.seo && !to.query.seo) {
    next({path: to.path, query: {...to.query, seo: '1'}})
  } else {
    next()
  }
}

router.beforeEach((to, from, next) => {
  if (localStorage.getItem("loginStatus") == "true") {
    // 已经登陆
    if (store.state.client_id === "") {
      Vue.prototype.$WS.createSocket();
      imInit();
    }
    // if(!store.state.chatStatus){
    getCusToken();
    // }
    store.commit("set_chatCount", 0);
  }
  if (to.matched.some(m => m.meta.auth)) {
    // 对路由进行验证
    if (localStorage.getItem("loginStatus") == "true") {
      // 已经登陆
      store.commit("set_loginStatus", localStorage.getItem("loginStatus"));
      store.commit(
        "set_userData",
        JSON.parse(localStorage.getItem("userData"))
      );
      store.commit("set_token", localStorage.getItem("token"));
      foxNext(to, from, next); // 正常跳转到你设置好的页面
    } else {
      // 未登录则跳转到登陆界面，query:{ Rurl: to.fullPath}表示把当前路由信息传递过去方便登录后跳转回来；
      next({ path: "/login", query: { Rurl: to.fullPath } });
    }
  } else {
    foxNext(to, from, next);
  }
  if (localStorage.getItem("loginStatus") == "false" && to.name == "Coupon") {
    foxNext(to, from, next);
  }
});

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

export default router
